import React from 'react';
import { isUndefined, isNull } from 'lodash';
import { Container } from 'react-bootstrap';

import { Loading, LoadingError, BackButton } from '@components/Base';
import SupportSection from '@components/SupportSection';
import { routeCancerQuoteBuyNewPage } from '@components/CancerQuoteBuyRoute';
import { HeaderSection } from '@components/HealthQuoteDetailsRoute/HealthQuoteDetailsPage/header-section';
import { ExclusionSection } from '@components/HealthQuoteDetailsRoute/HealthQuoteDetailsPage/exclusion-section';
import { DocumentSection } from '@components/HealthQuoteDetailsRoute/HealthQuoteDetailsPage/document-section';
import { HospitalSection } from '@components/HealthQuoteDetailsRoute/HealthQuoteDetailsPage/hospital-section';
import { MemberSection } from '@components/HealthQuoteDetailsRoute/HealthQuoteDetailsPage/member-section';
import { useQuoteOptionParams } from '@components/Feature/HealthQuote/hook';
import { routeCancerQuotePage } from '@components/HealthQuotePage';

import { useCancerQuoteFind } from '../hook';
import { routeCancerQuoteSendEmailPage } from '../route';
import { FeatureSection } from './feature-section';
import { BenefitSection } from './benefit-section';


const CancerQuoteDetailsPage = () => {
  const params = useQuoteOptionParams();
  const cancerQuote = useCancerQuoteFind();

  if (isUndefined(cancerQuote)) return <Loading />;
  if (isNull(cancerQuote)) return <LoadingError />;

  const { cancerPlanId, cancerPlanName } = cancerQuote;

  return (
    <>
      <Container className="mt-4">
        <BackButton className="mb-4" />
      </Container>

      <HeaderSection
        {...cancerQuote}
        planName={cancerPlanName}
        buyLinkTo={routeCancerQuoteBuyNewPage({ ...params, cancerPlanId })}
        sendEmailLinkTo={routeCancerQuoteSendEmailPage({ ...params, cancerPlanId })}
      />
      <FeatureSection {...cancerQuote} />
      <BenefitSection {...cancerQuote} />
      <ExclusionSection {...cancerQuote} />
      <DocumentSection {...cancerQuote} />
      <HospitalSection {...cancerQuote} />
      <MemberSection {...cancerQuote} formLinkTo={routeCancerQuotePage({ path: 'members', ...params })} />

      <SupportSection />
    </>
  );
};

export { CancerQuoteDetailsPage };
